import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import { fetchProductCategoryList, fetchProductDetails, fetchProductSubCategoryList, fetchRegularProductsList } from '../../../../thunk/lineOrdering.thunk';
import { PromotionSearchScroller } from '../AmwayProductSearch/PromotionSearchScroller';
import { getPriceFormat, isCartABOType, addProductsToCart, addProductsToCartPublic, STOCK_STATUS, INSTALLMENT_TYPE } from '../../../../services/promotion/utils.service';
import { ChipAssessment, HnWNumpadModal, SkeletonLoader, Slideup, commonConstant } from '../../../../common';
import { RegularProductSubCategory } from '../../../../model/RegularProduct.model';
import Product, { ProductItemType } from '../../PromotionTemplate/Product';
import { REGULAR_PRODUCTS_LABELS, SESSION_KEY, SOP_Product_CatId } from '../../../../common/commonConstant';
import './RegularProduct.scss';
import { updateCartData } from '../../../../actions/cartAction';
import { UpdateState } from '../../SelectProduct/PromotionProduct';
import { getCategoryColor, getDataFromSession } from '../../../../utill.func';
import CustomSweetAlert from '../../../../common/customSweetAlert/CustomSweetAlert';

const RegularProduct = ({ accountType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalPointValue, setTotalPointValue] = useState(0);
  const [totalBusinessVolume, setTotalBusinessVolume] = useState(0);
  const [isCategoryLoaded, setIsCategoryLoaded] = useState(false);
  const [totalSelected, setTotalSelected] = useState(0);
  const categoryList = useSelector(state => state.lineOrdering.REGULAR_CATEGORY);
  const [activeCategory, setActiveCategory] = useState({});
  const [activeSubCategory, setActiveSubCategory] = useState({});
  const [subCategoryforProducts, setSubCategoryforProducts] = useState({})
  const [activeAccordion, setActiveAccordion] = useState('');
  const [productLoading, setProductLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [productsAdded, setProductsAdded] = useState([]);
  const [loading, setLoading] = useState(false);
  const cart = useSelector(state => state.cartApi?.data);

  const subCategoryDataList = categoryList.SUB_CATEGORY?.data[activeCategory.id];
  const subCategoryList = [new RegularProductSubCategory({ ...activeCategory, name: REGULAR_PRODUCTS_LABELS.ALL_PRODUCTS }),
  ...subCategoryDataList?.length ? subCategoryDataList : []];

  useEffect(() => {
    !categoryList.data.length && dispatch(fetchProductCategoryList());

    return () => {
      dispatch({ type: "RESET_REGULAR_PRODUCT_QUANTITIES" });
    };
  }, []);

  useEffect(() => {
    if (categoryList.data.length) {
      setIsCategoryLoaded(true);
      setActiveCategory(categoryList.data[0]);
    }
  }, [categoryList.data]);

  useEffect(() => {
    if (subCategoryList && subCategoryList?.length) {
      setActiveSubCategory(subCategoryList[0]);
    }
  }, [subCategoryList?.length, activeCategory?.id]);

  useEffect(() => {
    isCategoryLoaded && !categoryList.SUB_CATEGORY?.data[activeCategory?.id] &&
      dispatch(fetchProductSubCategoryList(activeCategory?.id));
  }, [activeCategory, isCategoryLoaded]);

  useEffect(() => {
    isCategoryLoaded && activeSubCategory?.id && setSubCategoryforProducts(activeSubCategory);
  }, [activeSubCategory, isCategoryLoaded]);

  useEffect(() => {
    if (subCategoryforProducts?.id) {
      !categoryList.PRODUCTS.data[subCategoryforProducts?.id]
        && fetchProductsList();
    }
  }, [subCategoryforProducts?.id]);

  useEffect(() => {
    setProductsList(categoryList.PRODUCTS.data[subCategoryforProducts?.id]?.data?.map(product => {
      const addedProduct = productsAdded.find((p) => p.id === product.id);
      return addedProduct ? { ...product, quantity: addedProduct.quantity } : product;
    }));
  }, [subCategoryforProducts?.id, categoryList.PRODUCTS.data[subCategoryforProducts?.id]?.data]);

  const fetchProductsList = async () => {
    setProductLoading(true);
    await dispatch(fetchRegularProductsList({
      currentPage: (categoryList.PRODUCTS.data[subCategoryforProducts?.id]?.currentPage ?? 0) + 1,
      perPage: 10,
      categoryId: subCategoryforProducts?.id ?? '""'
    }));
    setProductLoading(false);
  };

  const handleModalClose = () => setIsModalOpen(false);
  const handleModalOpen = () => setIsModalOpen(true);

  const renderCategory = categoryList.data.filter(item => item.id !== SOP_Product_CatId).map((item, index) =>
    <div key={`main${index}`} className={`regular-product-category ${item.id === activeCategory.id ? `${getCategoryColor(item.color)} --active` : ''}`}
      onClick={() => setActiveCategory(item)}>
      <img className="regular-product-category-icon" src={item.image_url} />
      {item.name}
    </div>);

  const renderSubCategory = subCategoryList?.map((item) => {
    return <div key={`subCat-${item.id}`} className={`regular-product-sub_category ${item.id === activeSubCategory.id ? `--active` : ''}`}
      onClick={() => setActiveSubCategory(item)}>
      {item.name}
    </div>
  });

  const renderProducts = (searchedProducts) => {
    if (searchedProducts && searchedProducts.length === 0) {
      return <></>;
    }

    const props = {
      totalPrice,
      setTotalPrice,
      totalPointValue,
      setTotalPointValue,
      totalBusinessVolume,
      setTotalBusinessVolume,
      totalSelected,
      productItemType: ProductItemType.SELECT,
      setTotalSelected,
      setProductSelected,
    };

    return <PromotionSearchScroller
      items={searchedProducts}
      loading={productLoading}
      itemComponent={Product}
      cartData={cart[0]}
      loaderComponent={ListLoader}
      fetchData={fetchProductsList}
      shouldFetchData={!productLoading && searchedProducts.length < categoryList.PRODUCTS.data[subCategoryforProducts?.id]?.total}
      itemProps={props} />
  };

  const setQuantityToProduct = (product, quantity) => {
    product.quantity = quantity;

    if (product.kitEntries?.length > 0) {
      product.kitEntries.forEach((kitEntry) => {
        const configuredQty = kitEntry.configuredQty;

        if (kitEntry.product?.baseOptions?.length > 0) {
          const baseOptions = kitEntry.product.baseOptions[0];
          let qtyFlag = false;

          if (baseOptions.options.find(el => el.quantity)) {
            qtyFlag = true;
          }

          for (const [index, option] of baseOptions.options.entries()) {
            if (kitEntry.product.baseProduct) {
              if (baseOptions.selectedId) {
                const qty = baseOptions.selectedId === option.id ? configuredQty : 0;
                option.quantity = qty;
                option.lastQuantity = qty;
              }
            } else {
              let qty = 0;
              if (!qtyFlag && option.stock?.stockLevelStatus !== STOCK_STATUS.outOfStock && !option.quantity) {
                qty = configuredQty;
                qtyFlag = true;
              } else {
                if (option.quantity || option.quantity === 0) {
                  qty = option.quantity;
                  qtyFlag = true;
                }
              }
              option.quantity = qty;
              option.lastQuantity = qty;
            }
          };
        }
      });
    }

    return product;
  };

  const setProductSelected = async (productId, quantity, updateState, rootProductId) => {
    let updatedKitEntries = [];

    const baseProduct = productsList?.find(p => p.id === productId);

    if (baseProduct?.isKitProduct && quantity > 0) {
      setLoading(true);
      const product_details = await dispatch(fetchProductDetails(productId));
      updatedKitEntries = baseProduct.kitEntries?.length ? baseProduct.kitEntries : product_details.kitEntries.length ? product_details.kitEntries : [];

      setQuantityToProduct({ ...product_details, kitEntries: updatedKitEntries }, quantity);
      setLoading(false);
    }
    setProductsList((prevProducts) => {
      if (!prevProducts) return [];

      const updatedProducts = prevProducts.map((product) => {
        if (product.id === productId) {
          product.quantity = quantity;
          if (updatedKitEntries.length > 0) {
            product.kitEntries = updatedKitEntries;
          }
        }

        if (product.kitEntries?.length > 0) {
          product.kitEntries.forEach((kitEntry) => {
            if (kitEntry.product?.baseOptions?.length > 0) {
              const baseOptions = kitEntry.product.baseOptions[0];

              baseOptions.options.forEach((option) => {
                if (kitEntry.kitEntryCode?.includes(rootProductId)) {
                  if (updateState === UpdateState.FINISH) {
                    option.lastQuantity = option.quantity;
                  } else if (option.id === productId) {
                    if (updateState === UpdateState.CLEAR) {
                      option.quantity = option.lastQuantity;
                    }
                    if (updateState === UpdateState.CHANGE) {
                      option.quantity = quantity;
                    }
                  }
                }
              });
            }
          });
        }
        return product;
      });

      const updatedProduct = updatedProducts.find((product) => product.id === productId);

      if (!updatedProduct) return updatedProducts;

      setProductsAdded((prevProductsAdded) => {
        const existingProductIndex = prevProductsAdded.findIndex((p) => p.id === productId);

        if (existingProductIndex !== -1) {
          return prevProductsAdded.map((p) =>
            p.id === productId ? { ...p, quantity } : p
          );
        } else {
          return [...prevProductsAdded, updatedProduct];
        }
      });

      return updatedProducts;
    });
  };

  const addToCart = async () => {
    try {
      const customer = getDataFromSession('customer');
      if (customer && customer?.type?.toLowerCase() === 'public') {
        return;
      };
      if (totalPrice === 0) {
        return;
      }
      setLoading(true);
      const cartId = sessionStorage.getItem(SESSION_KEY.pifCartId);
      const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));

      const response = !customerFOA
        ? await addProductsToCart(cartId, productsAdded)
        : await addProductsToCartPublic(cartId, productsAdded, cart[0].guid);
      sessionStorage.setItem('guid', cart[0].guid);
      setLoading(false);
      if (response.error) {
        return CustomSweetAlert({
          title: "",
          text: response.error[0].th_message,
          confirmButtonText: "ตกลง",
        });
      }
      //Update latest cartData to redux
      await dispatch(updateCartData([response.data]));
      goToCart();
    } catch (e) {
      setLoading(false);
    }
  }

  const ListLoader = () => Array(2).fill().map((el, index) => <SkeletonLoader key={`pList${index}`} className="--skeleton" />);

  const goToCart = () => {
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.FALSE);
    history.push({ pathname: commonConstant.pathCartPromotion, search: urlParams.toString() });
  }

  const handleSelectAccordion = (eventKey) => {
    const upperSubCategory = subCategoryDataList.find(categoryItem => categoryItem.id === eventKey);
    const shouldNotExpand = upperSubCategory?.sub_category?.length === 0;
    if (shouldNotExpand) {
      setActiveSubCategory(upperSubCategory);
      handleModalClose();
      return;
    }
    setActiveAccordion(eventKey);
  }

  return (
    <div className="regular-product-container">
      <LoadingOverlay
        text="Loading"
        spinner
        active={loading}
        styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
      />
      <div className="regular-product-category-container">
        {categoryList.loading ? Array(4).fill().map((el, index) => <SkeletonLoader key={`category${index}`} className="--skeleton" />) : renderCategory}
      </div>
      <div className="regular-product-sub_category-container">
        <img onClick={handleModalOpen} alt="sub-category-menu" className="regular-product-sub_category__menu-icon" src="/images/common/hamburger.svg" />
        {categoryList.SUB_CATEGORY.loading ? Array(4).fill().map((el, index) => <SkeletonLoader key={`subcategory${index}`} className="--skeleton" />) : renderSubCategory}
      </div>
      <div className="regular-product-listing-container">
        <div className="regular-product-breadcrumb-total">
          {categoryList.loading ?
            <SkeletonLoader className="--breadcrumb" /> :
            activeCategory && <span>{activeCategory.name}</span>}
          {categoryList.SUB_CATEGORY.loading ?
            <SkeletonLoader className="--breadcrumb" /> :
            activeCategory && activeSubCategory && <span>{` > ${activeSubCategory?.name ?? ""}`}</span>}
          {categoryList.PRODUCTS.loading || categoryList.SUB_CATEGORY.loading || productLoading ?
            <SkeletonLoader className="--breadcrumb" /> :
            <span>{`(${categoryList.PRODUCTS.data[subCategoryforProducts?.id]?.total ?? ''} รายการ)`}</span>}
        </div>
        <div className="regular-product-listing">
          {categoryList.PRODUCTS.loading || categoryList.SUB_CATEGORY.loading ?
            <ListLoader /> :
            renderProducts(productsList || [])
          }
        </div>
      </div>
      <div className='regular-product-footer'>
        <div className='regular-footer'>
          <div className='regular-price-pvbv-container'>
            <div className='regular-panel-footer-price'>
              <span>฿ {getPriceFormat(totalPrice)}</span>
            </div>
            {isCartABOType(accountType) && (
              <div className='pvbv-total'>
                PV {totalPointValue.toLocaleString()} / BV{' '}
                {totalBusinessVolume.toLocaleString()}
              </div>
            )}
          </div>
          {!totalPrice ? (
            <span className='add-to-cart disabled' disabled>
              <img src='/images/promotion/icon_cart.svg' />
              <span className='add-to-cart-text-disabled'>{REGULAR_PRODUCTS_LABELS.ADD_TO_CART}</span>
            </span>
          ) : (
            <span className='add-to-cart active' onClick={addToCart}>
              <img src='/images/promotion/icon_cart_active.svg' />
              <span className='add-to-cart-text-active'>
                {REGULAR_PRODUCTS_LABELS.ADD_TO_CART}
              </span>
            </span>
          )}
        </div>
      </div>
      <HnWNumpadModal openNumpad={isModalOpen} onBackgroundClick={handleModalClose}>
        <div className="category-menu-modal-header">
          {REGULAR_PRODUCTS_LABELS.SELECT_SUBCATEGORY}
          <img src="/images/Close.svg" alt="close-btn" onClick={handleModalClose} />
        </div>
        <div>
          <button className="accordion-first-item">{subCategoryList[0].name}</button>
          {subCategoryDataList?.length > 0 &&
            <Accordion onSelect={handleSelectAccordion} activeKey={activeAccordion}>
              {subCategoryDataList.map((categoryItem, index) =>
                <Accordion.Item key={`accordian-item-${index}`} eventKey={categoryItem.id}>
                  <Accordion.Header
                    bsPrefix={`accordion-header ${categoryItem.sub_category.length ? '--expandable' : ''}`}
                  >{categoryItem.name}</Accordion.Header>
                  <Accordion.Body>
                    <div className="accordion-body-content-wrapper">
                      {categoryItem.sub_category.map(categoryItemInner => <ChipAssessment
                        chipClass="regular-product-menu-chip"
                        text={categoryItemInner.name}
                        onClick={() => { setActiveSubCategory(categoryItemInner); handleModalClose() }} />
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>)}
            </Accordion>}
        </div>
      </HnWNumpadModal>
      <Slideup bottomGap="100px" />
    </div>
  )
}

export default RegularProduct
